import DonationHistory from './DonationHistory';

export default DonationHistory;